var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-form",
            { ref: "formUser" },
            [
              _c(
                "base-card",
                [
                  _c("v-card-title", [_vm._v("Registrar Usuarios ")]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "cliente",
                                attrs: {
                                  items: _vm.detailClients,
                                  "item-text": "NombreCompania",
                                  "item-value": "IdCompania",
                                  label: "Compañia",
                                  "prepend-inner-icon": "mdi-sitemap",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  filter: "",
                                  "search-input": "",
                                  required: "",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "prepend-item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item",
                                          [
                                            _c(
                                              "v-list-item-content",
                                              [
                                                _c(
                                                  "v-list-item-title",
                                                  [
                                                    _c("v-text-field", {
                                                      staticClass:
                                                        "search-field",
                                                      attrs: {
                                                        placeholder: "Buscar",
                                                        "prepend-inner-icon":
                                                          "mdi-magnify",
                                                        "hide-details": "",
                                                      },
                                                      model: {
                                                        value: _vm.search,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.search = $$v
                                                        },
                                                        expression: "search",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.dataUser.cliente,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataUser, "cliente", $$v)
                                  },
                                  expression: "dataUser.cliente",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "name",
                                attrs: {
                                  label: "Nombre",
                                  "prepend-inner-icon": "mdi-account-tie",
                                  clearable: "",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataUser.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataUser, "name", $$v)
                                  },
                                  expression: "dataUser.name",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "email",
                                attrs: {
                                  label: "Correo",
                                  "prepend-inner-icon": "mdi-email",
                                  clearable: "",
                                  rules: _vm.emailRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataUser.email,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataUser, "email", $$v)
                                  },
                                  expression: "dataUser.email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-text-field", {
                                ref: "password",
                                attrs: {
                                  label: "Contraseña",
                                  "prepend-inner-icon": "mdi-account-key",
                                  clearable: "",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataUser.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataUser, "password", $$v)
                                  },
                                  expression: "dataUser.password",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c("v-select", {
                                ref: "rol",
                                attrs: {
                                  items: _vm.typeRol,
                                  "item-text": "textRol",
                                  "item-value": "valueRol",
                                  label: "Rol",
                                  "prepend-inner-icon": "mdi-account-network",
                                  rules: _vm.formRules,
                                  "error-messages": _vm.errorMessages,
                                  required: "",
                                },
                                model: {
                                  value: _vm.dataUser.rol,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataUser, "rol", $$v)
                                  },
                                  expression: "dataUser.rol",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "4" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-2",
                                  staticStyle: {
                                    "background-color": "rgb(204 33 40)",
                                    color: "white !important",
                                  },
                                  on: { click: _vm.validateUser },
                                },
                                [_vm._v(" Registrar ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-alert",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.successAlert,
                                  expression: "successAlert",
                                },
                              ],
                              attrs: { type: "success", text: "" },
                            },
                            [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }